import { render, staticRenderFns } from "./HeadingTabs.vue?vue&type=template&id=8875e7fc&scoped=true&"
import script from "./HeadingTabs.vue?vue&type=script&lang=js&"
export * from "./HeadingTabs.vue?vue&type=script&lang=js&"
import style0 from "./HeadingTabs.vue?vue&type=style&index=0&id=8875e7fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8875e7fc",
  null
  
)

export default component.exports